class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    // if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      // if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

// customElements.define('cart-drawer-items', CartDrawerItems);


const interval2 = setInterval(function () {
  document.querySelectorAll('[class^="styles_TrashButton__deleteButton"]').forEach(button => {
      button.addEventListener('click', function() {
          const cartBody = document.querySelector('.upcart-cart-body');
          setTimeout(() => {
              const loaderToRemove = document.querySelector('[class^="styles_ProductRow__loader__"]');
            
              if(loaderToRemove) {
                loaderToRemove.style.display = 'none';
              }
          }, 50);
        
          // Check if loader is already present
          const existingLoader = cartBody.querySelector('.loader-cart');

            if (!existingLoader) {
                // Create loader element
                const loader = document.createElement('div');
                loader.className = 'loader-cart';
                loader.innerHTML = '<div class="spinner"></div>';

                // Add loader to the cart body
                cartBody.appendChild(loader);
                
                setTimeout(() => {
                    cartBody.removeChild(loader);
                }, 3000);
            }
      });
  });
    jQuery('a.upcart-product-title-link').each(function() {
      // Get the text of the anchor
      var text = $(this).text();
      // Replace the anchor with a text node
      $(this).replaceWith(text);
  });
}, 1000);

let intervalId2; // Declare a variable to hold the interval ID

function addDiscountTag() {
    const productItem = document.getElementById("45962219880615:f3f6ae8b6013bc0a684fd594c9e222f0");
    if (productItem) {
        if (productItem.querySelector('.upcart-discount-code-badge')) return;

        const discountBadge = document.createElement("div");
        discountBadge.className = "upcart-discount-code-badge DiscountCodeBadge_discountBadge__jEQg8";
        discountBadge.innerHTML = `
            <div class="upcart-discount-code-icon DiscountCodeBadge_icon__lfykU">
                <svg viewBox="0 0 20 20">
                    <path d="M13 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path>
                    <path fill-rule="evenodd" d="M11.276 3.5a3.75 3.75 0 0 0-2.701 1.149l-4.254 4.417a2.75 2.75 0 0 0 .036 3.852l2.898 2.898a2.5 2.5 0 0 0 3.502.033l4.747-4.571a3.25 3.25 0 0 0 .996-2.341v-2.187a3.25 3.25 0 0 0-3.25-3.25h-1.974Zm-1.62 2.19a2.25 2.25 0 0 1 1.62-.69h1.974c.966 0 1.75.784 1.75 1.75v2.187c0 .475-.194.93-.536 1.26l-4.747 4.572a1 1 0 0 1-1.401-.014l-2.898-2.898a1.25 1.25 0 0 1-.016-1.75l4.253-4.418Z"></path>
                </svg>
            </div>
            <span class="upcart-discount-code-text DiscountCodeBadge_title__vl5H6">Free Toner</span>
        `;

        // Append the discount badge to the price container
        const priceContainer = productItem.querySelector(".styles_ProductRow__price__Ta93X");
        if (priceContainer) {
            priceContainer.appendChild(discountBadge);
        }
    } else {
        // console.log("Product ID not found.");
    }
}

// Function to check for the presence of 'upcartPopupShow'
function checkUpcartPopup() {
    const upcartPopup = document.getElementById("UpcartPopup");
  
    if (upcartPopup && upcartPopup.classList.contains("upcartPopupShow")) {
        addDiscountTag();
      removeLinkForGiftProduct();
    }
}

intervalId2 = setInterval(checkUpcartPopup, 2000);



function removeLinkForGiftProduct() {
       var targetProductNames = [
          'Deluxe Gift', 
          'Ship Insure',
          'The Brightening Pads + A Mystery Gift',
          'The Toner - GIFT',
          'The Toner',
          'Collagen Bounce',
          'Exfoliate & Tone',
      ];

      const productRows = document.querySelectorAll('.upcart-product-item');
      productRows.forEach(row => {
          const productTitle = row.querySelector('.upcart-product-title-link');
          const productImage = row.querySelector('.upcart-product-image-wrapper');
         
       
          if (productTitle) {
            
              const productName = productTitle.innerText.trim();
              if (targetProductNames.includes(productName)) {

                  const quantityMinus = row.querySelector('.upcart-product-quantity-minus');
                  const quantityInput = row.querySelector('.upcart-product-quantity-input');
                  const quantityPlus = row.querySelector('.upcart-product-quantity-plus');
          
                  if(quantityMinus) quantityMinus.remove();
                  if(quantityInput) quantityInput.remove();
                  if(quantityPlus) quantityPlus.remove();

                
                  productTitle.outerHTML = productTitle.innerHTML;
                  productTitle.href = '#';
                  if (productImage) {
                      const productImageLink = productImage.querySelector('a');
                      if (productImageLink) {
                          productImageLink.href = '#';
                          productImageLink.style.cursor = 'unset';
                      }
                  }
              }
          }
      });
}
// const interval = setInterval(function () {
//   jQuery.getJSON('https://carrotstick.com/cart.json', function (cart) {
//     var discount_code = cart.cart_level_discount_applications;
//     if(discount_code){
//         if(discount_code[0]){
//             var discount_code_txt = discount_code[0].title;
//             if(discount_code_txt){
//                 // console.log('discount_code_txt ' , discount_code_txt);
//                   if(discount_code_txt == 'BIGGIFT'){
//                     jQuery.ajax({
//                       type: "POST",
//                       url: "/cart/update.js",
//                       data: "updates[44630539108519]=1",
//                       dataType: "json",
                     
//                       success: function(response) {
//                         console.log('Success:', response);
//                       },
//                         error: function(xhr, status, error) {
//                             console.error('Error updating the cart:', error);
//                       }
//                     });
//                   }else{
                    
//                   }
//             }
//         }else{
//            jQuery.ajax({
//                       type: "POST",
//                       url: "/cart/update.js",
//                       data: "updates[44630539108519]=0",
//                       dataType: "json",
//                        success: function(response) {
//                         console.log('Success:', response);
//                       },
//                         error: function(xhr, status, error) {
//                             console.error('Error updating the cart:', error);
//                       }
//                     });
//         }
//     }
//     clearInterval(interval)
//   });
// }, 2000);
